<div class="content">
  <ng-container *ngIf="chats && chats.length > 0; else emptyContent">
    <div class="d-flex mb-2" style="align-items: center; justify-content: space-between">
      <span>{{'Discussions' | translate}}</span>
      <div class="action-btn">
        <a class="btn btn-sm btn-circle btn-outline-primary" (click)="redirectToTable()">
          <i class="icon-calendar"></i>
        </a>
      </div>
    </div>
    <div class="mb-2" *ngFor="let chat of chats; let i = index; trackById">
      <app-card-discussion [index]="i+1" [data]="chat" [routerLink]="['edit', chat.id]"></app-card-discussion>
    </div>
  </ng-container>
</div>
<ng-template #emptyContent>
  <div>
    {{ 'No thread related to this asset' | translate }}.
  </div>
</ng-template>